export default {
  XS: "xs",
  SM: "sm",
  MD: "md",
  LG: "lg"
};
